<template>
  <div class="space-y-6">
    <!-- Name Field -->
    <div class="space-y-2">
      <label for="name" class="text-sm font-medium text-gray-700">
        Name <span class="text-red-500">*</span>
      </label>
      <InputText
        id="name"
        v-model="name"
        class="w-full"
        :class="{ 'p-invalid': nameError }"
        placeholder="Enter full name"
      />
      <small v-if="nameError" class="text-red-500">
        {{ nameError }}
      </small>
    </div>

    <!-- Email Field -->
    <div class="space-y-2">
      <label for="email" class="text-sm font-medium text-gray-700">
        Email <span v-if="!noEmail" class="text-red-500">*</span>
      </label>
      <InputText
        id="email"
        v-model="email"
        type="email"
        class="w-full"
        :class="{ 'p-invalid': emailError }"
        placeholder="Enter email address"
        :disabled="noEmail"
      />
      <small v-if="emailError" class="text-red-500">
        {{ emailError }}
      </small>
      <small v-if="noEmail" class="text-gray-500">
        This athlete won't be able to log in. A parent or guardian manages them
        from their own account.
      </small>
    </div>

    <slot name="after-email" />

    <!-- Phone Field -->
    <PhoneNumber id="phone" v-model="phoneNumber" label="Phone" />
  </div>
</template>

<script setup lang="ts">
import InputText from "primevue/inputtext";
import PhoneNumber from "@/shared/components/PhoneNumber.vue";

interface Props {
  nameError?: string;
  emailError?: string;
}

defineProps<Props>();

const name = defineModel<string>("name", { default: "" });
const email = defineModel<string>("email", { default: "" });
const phoneNumber = defineModel<string>("phoneNumber", { default: "" });
const noEmail = defineModel<boolean>("noEmail", { default: false });
</script>
